import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Pie, Doughnut } from "react-chartjs-2";
import { Chart } from "chart.js";
import { useSelector } from "react-redux";
import { common_axios } from "../../../App";
import moment from "moment";
import { useEffect } from "react";
import { Backdrop } from "@mui/material";
import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Swal from "sweetalert2";

Chart.register(ChartDataLabels);
// import { Doughnut } from "react-chartjs";
export default function PieGraph({ dateee, empId, defineSt }) {
  console.log(dateee, "date is ere");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);

  const globalData = useSelector((state) => state.buttonSlice.button);

  // const getPieCahrt = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`attendance/pieChart`, {
  //       userGroup: userModal,
  //       userId: localStorage.getItem("UserId"),
  //       month: moment(dateee, "MMMM-YYYY").month() + 1,
  //       year: moment(dateee, "MMMM-YYYY").year(),
  //     });
  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       let varrr = false;
  //       for (let index = 0; index < res.data?.chartResponses?.length; index++) {
  //         if (
  //           res.data?.chartResponses?.[index]?.count != 0 &&
  //           res.data?.chartResponses?.[index]?.count != null
  //         ) {
  //           varrr = true;
  //         }
  //       }
  //       // console.log({ varrr });
  //       if (!varrr) {
  //         setData([]);
  //       } else {
  //         setData({
  //           labels: res?.data?.chartResponses?.map((dd) => dd?.name),

  //           datasets: [
  //             {
  //               label: "",
  //               backgroundColor: [
  //                 "#F7B596",
  //                 "#90EE90",
  //                 "#96F7DF",
  //                 "#F7DC96",
  //                 "#F39C12",
  //                 "#3C8DBC",
  //                 "#00C0EF",
  //               ],
  //               // borderColor: [
  //               //   "#FF4E00",
  //               //   "#128408",
  //               //   "#000087",
  //               //   "#EFB701",
  //               //   "#F74300",
  //               //   "#000087",
  //               //   "#1F3151",
  //               // ],
  //               borderColor: [
  //                 // "#000000",
  //                 // "#000000",
  //                 // "#000000",
  //                 // "#000000",
  //                 // "#000000",
  //                 // "#000000",
  //                 // "#000000",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //               ],
  //               borderWidth: 2,
  //               //stack: 1,

  //               data: res?.data?.chartResponses?.map((dd) => dd?.count),
  //             },
  //           ],
  //         });
  //       }
  //       setOpen(false);
  //     } else {
  //       setOpen(false);
  //       await toast.error(res.data.statusDescriptions.statusDescription, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (err) {
  //     setOpen(false);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Something Went Wrong !! Please check your network ",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   }
  // };

  const userModal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  // const getPieCahrtemp = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`attendance/pieChart`, {
  //       userGroup: userModal,
  //       userId: empId,
  //       month: moment(dateee, "MMMM-YYYY").month() + 1,
  //       year: moment(dateee, "MMMM-YYYY").year(),
  //     });
  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       let varrr = false;
  //       for (let index = 0; index < res.data?.chartResponses?.length; index++) {
  //         if (
  //           res.data?.chartResponses?.[index]?.count != 0 &&
  //           res.data?.chartResponses?.[index]?.count != null
  //         ) {
  //           varrr = true;
  //         }
  //       }
  //       // console.log({ varrr });
  //       if (!varrr) {
  //         setData([]);
  //       } else {
  //         setData({
  //           labels: res?.data?.chartResponses?.map((dd) => dd?.name),

  //           datasets: [
  //             {
  //               label: "",
  //               backgroundColor: [
  //                 "#F7B596",
  //                 "#90EE90",
  //                 "#96F7DF",
  //                 "#F7DC96",
  //                 "#F39C12",
  //                 "#3C8DBC",
  //                 "#00C0EF",
  //               ],
  //               borderColor: [
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //                 "#ffff",
  //               ],
  //               borderWidth: 2,
  //               //stack: 1,

  //               data: res?.data?.chartResponses?.map((dd) => dd?.count),
  //             },
  //           ],
  //         });
  //       }
  //       setOpen(false);
  //     } else {
  //       setOpen(false);
  //       await toast.error(res.data.statusDescriptions.statusDescription, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (err) {
  //     setOpen(false);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Something Went Wrong !! Please check your network ",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   }
  // };

  // useEffect(() => {
  //   getPieCahrt();
  // }, [dateee, globalData]);
  // useEffect(() => {
  //   if (empId) {
  //     getPieCahrtemp();
  //   }
  // }, [empId, dateee, defineSt]);

  useEffect(() => {
    let pieArr = [];
    let ObjectKeysArr = [];
    let ObjectValueArr = [];
    // if (dateee) {
    for (let index = 0; index < dateee.length; index++) {
      const element = dateee[index];

      delete element.propertyName;
      delete element.id;

      // Available = element.available;
      // Occupied = element.occupied;
      // Rooms = element.rooms;
      // TotalBedsInlWarden = element.totalBedsIncWarden;
      // TotalBedsExlWarden = element.totalBeds;
      const modifiedKeysObj = {};
      for (let key in element) {
        if (element.hasOwnProperty(key)) {
          const modifiedKey =
            key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
          modifiedKeysObj[modifiedKey] = element[key];
        }
      }
      console.log(element, "elementelement");
      pieArr.push(element);
      ObjectKeysArr = Object.keys(modifiedKeysObj);
      ObjectValueArr = Object.values(element);
    }
    console.log(
      dateee,
      pieArr,
      ObjectKeysArr,
      ObjectValueArr,

      "dateee?.map((dd) => "
    );

    setData({
      labels: ObjectKeysArr,

      datasets: [
        {
          label: "",
          backgroundColor: [
            "#F7B596",
            "#90EE90",
            "#96F7DF",
            "#F7DC96",
            "#F39C12",
          ],
          // borderColor: [
          //   "#FF4E00",
          //   "#128408",
          //   "#000087",
          //   "#EFB701",
          //   "#F74300",
          //   "#000087",
          //   "#1F3151",
          // ],
          borderColor: [
            // "#000000",
            // "#000000",
            // "#000000",
            // "#000000",
            // "#000000",
            // "#000000",
            // "#000000",
            "#ffff",
            "#ffff",
            "#ffff",
            "#ffff",
            "#ffff",
          ],
          borderWidth: 2,
          // stack: 1,

          data: ObjectValueArr,
        },
      ],
    });
    // }
  }, [dateee]);

  const options = {
    responsive: true,
    legend: {
      display: false,
    },
    // scales: {
    //   yAxes: [
    //     {
    //       scaleLabel: {
    //         display: true,
    //         //labelString: "Percentage"
    //       },
    //     },
    //   ],
    // },
    scale: {
      pointLabels: {
        fontStyle: "bold",
        textAlign: "left",
        alignItems: "left",
      },
    },

    // type: "Pie",
    type: "Doughnut",
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      datalabels: {
        display: true,
        color: "black",
        // weight: "bolder",
        // font: "bolder 20px Comic Sans MS",
        font: {
          size: "12px",
        },
        align: "center",
        height: "100%",
        // padding: {
        //   right: 2,
        // },
        // labels: {
        //   padding: { top: 0 },
        //   title: {
        //     font: {
        //       weight: "bolder",
        //       size: "30px",
        //     },
        //   },
        //   value: {
        //     color: "white",
        //     weight: "bolder",
        //     size: "20px",
        //   },
        // },
        formatter: function (value, name) {
          if (value != 0) return "\n" + value;
          else return "";
        },
      },
    },
  };

  let initialValue = 0;
  let sum = data?.datasets?.[0]?.data?.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    initialValue
  );

  // console.log("9jo0", sum);
  //
  // const textCenter = {
  //   id: "textCenter",
  //   beforeDatasetsDraw(chart, args, pluginOptions) {
  //     const { ctx, data } = chart;
  //     const initialValue = 0;
  //     const sumWithInitial = data?.datasets?.[0]?.data?.reduce(
  //       (accumulator, currentValue) => accumulator + currentValue,
  //       initialValue
  //     );

  //     ctx.save();
  //     ctx.textAlign = "center";
  //     ctx.font = "bolder 10px Comic Sans MS";
  //     // ctx.fillStyle = "red";
  //     ctx.fillText(
  //       `Total :${sumWithInitial}`,
  //       chart.getDatasetMeta(0).data[0].x,
  //       chart.getDatasetMeta(0).data[0].y
  //     );
  //   },
  // };

  console.log(data, "data");
  return (
    <>
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        // onClick={handleClose}
      >
        <Loader />
      </Backdrop>

      {!open && data?.labels?.length > 0 ? (
        <Doughnut
          // className="mt-4"
          data={data}
          width={null}
          height={null}
          options={options}
          // plugins={[textCenter]}
        />
      ) : (
        <div className="text-center m-auto">
          <h6>No data Found</h6>
        </div>
      )}
    </>
  );
}
